import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { toaster } from "../../actions/showToast";

export default function AddLink(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onClickAddLink = () => {
    console.log("--Add Link..");
    dispatch(toaster(t("Click a point to add a button Link"), "warning"));
    props.changeMyTool("addlink");
  };
  return (
    <li onClick={onClickAddLink}>
      <span
        className={`button normal-btn next-page ${
          props.shouldShowButtonLabels ? "show-label-span" : ""
        } ${
          props.activeButton === "addlink" ? "active" : ""
        }`}
        title={t("Add Link")}
        data-tip={t("Add Link")}
      >
        <img
          src={require("../../assets/img/svg/tools-link.svg")}
          alt={t("Add Link")}
        />
        {props.shouldShowButtonLabels && <span className="show-label-text">{t("Link")}</span>}
      </span>
    </li>
  );
}
